import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import PromoCodeUsageData from "./promo-code-usage-data";
import PromoCodeUsageForm from "./promo-code-usage-form";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const PromoCodeUsed = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <PromoCodeUsageForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <PromoCodeUsageData />
    </React.Fragment>
  );
});
export default PromoCodeUsed;
